import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const XAd = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14954)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M193.541 26.7351C193.625 26.8134 193.693 26.9076 193.741 27.0122C193.788 27.1168 193.815 27.2297 193.819 27.3446C193.823 27.4595 193.805 27.5741 193.764 27.6818C193.724 27.7895 193.663 27.8883 193.585 27.9723L186.466 35.6067L194.323 46.0367C194.421 46.1666 194.48 46.3212 194.495 46.4831C194.51 46.645 194.479 46.8078 194.407 46.9533C194.334 47.0988 194.222 47.2211 194.084 47.3067C193.946 47.3922 193.786 47.4375 193.624 47.4376H188.831C188.695 47.4377 188.561 47.4062 188.44 47.3458C188.319 47.2854 188.213 47.1976 188.132 47.0893L182.602 39.7507L175.694 47.1593C175.536 47.3291 175.317 47.429 175.085 47.4371C174.853 47.4453 174.627 47.3609 174.457 47.2026C174.288 47.0444 174.188 46.8252 174.18 46.5932C174.172 46.3613 174.256 46.1356 174.414 45.9658L181.533 38.3315L173.676 27.9015C173.578 27.7716 173.518 27.6171 173.504 27.4553C173.489 27.2934 173.519 27.1307 173.592 26.9853C173.664 26.8398 173.776 26.7174 173.914 26.6318C174.052 26.5462 174.211 26.5008 174.374 26.5006H179.168C179.303 26.5007 179.437 26.5321 179.558 26.5926C179.679 26.653 179.785 26.7407 179.866 26.8488L185.396 34.1875L192.303 26.7788C192.381 26.6947 192.475 26.6268 192.58 26.579C192.684 26.5313 192.797 26.5046 192.912 26.5005C193.027 26.4965 193.142 26.5151 193.249 26.5553C193.357 26.5956 193.457 26.6567 193.541 26.7351ZM184.66 36.1186C184.635 36.09 184.612 36.0599 184.591 36.0285L178.731 28.2497H176.128L189.266 45.6885H191.87L184.66 36.1186Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14954">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
XAd.displayName = 'XAd';
